import {ActiveUserService, CEProtocol, CEConstructor, ListSpecType} from 'lionheartland';
import {HttpClient} from 'lionheartland';
import {EOOrganizationInviteService} from '../../core/organization-invite/eo-organization-invite';
import {SOGetOrganizationInvite} from '../../core/organization-invite/so-get-organization-invite';
import {RAPutOrganizationInvite} from './ra-put-organization-invite';
import {RAPostOrganizationInvite} from './ra-post-organization-invite';
import {RADeleteOrganizationInvite} from './ra-delete-organization-invite';
import {AbstractEntityCore} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import { CEOrganizationInvite } from "./ce-organization-invite"


export class OrganizationInviteCoreBase extends AbstractEntityCore implements EntityCoreProtocol {

  type = 'organizationInvite';
  title = 'Organization invite';
  ceProtocol: CEConstructor = CEOrganizationInvite

  entityService: EOOrganizationInviteService;
  soGetClass = SOGetOrganizationInvite;
  soGet: SOGetOrganizationInvite;


  constructor(
    public activeUserService: ActiveUserService,
  ) {
    super(
      activeUserService,
      EOOrganizationInviteService,
      null,
    );
    this.adapters = [
      new RAPostOrganizationInvite(this),
      new RAPutOrganizationInvite(this),
      new RADeleteOrganizationInvite(this),
    ];
    this.resetSoGet()
    this.setDefaultAdapters();
    this.finalInit();
  }

  resetSoGet() {
    this.soGet = new SOGetOrganizationInvite();
    this.soGet.queryOptions.limit = this.limit;
  }


}